import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import { useQueryClient } from 'react-query';
import classes from 'components/Settings/Components/RolesManagement/components/rolesManagement.module.scss';
import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';
import Icon from 'components/common/Icons/icon';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useMutationDeleteRole } from 'components/Settings/Components/RolesManagement/queries/useQueryRolesManagement';

export const RowOptionsCell = ({ row }) => {
    const { name, id } = row.original;
    const [show, setShow] = useState<boolean>(false);
    const history = useHistory();
    const queryClient = useQueryClient();
    const { pathname } = useLocation();
    const mutation = useMutationDeleteRole();
    const { handleSnackBar } = useCustomSnackBar();

    const handleEdit = () => {
        history.push(`${pathname}/${settingsConfig.roleManagementEditRole.link}/${id}`);
    };

    const handleDelete = () => {
        mutation.mutate(name, {
            onSuccess: () => {
                handleSnackBar('Successfully deleted!', 'success');
            },
            onError: (error) => {
                DEFAULT_ERROR({ error, handleError: handleSnackBar });
            },
            onSettled: () => {
                queryClient.invalidateQueries('getRolesList');
            },
        });

        setShow(false);
    };

    return (
        <div className={classes.actions}>
            <CustomizedRoundIcon onClick={handleEdit}>
                <Icon name={'edit-user-profile'} />
            </CustomizedRoundIcon>

            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <Icon name={'BIN'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete role ${name}?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
